import { render } from 'react-dom';
import VideoPlayerPage, { Props } from 'js/videos/player/VideoPlayerPage';
import { TruncateText } from 'js/liswp/TruncateText';
import registerForRails from 'js/utils/registerForRails';
import globalAssign from 'js/utils/assign_global';

function renderVideoPlayerPage(elementId: string, props: Props) {
  render(<VideoPlayerPage {...props} />, document.getElementById(elementId));
}

globalAssign('Aedu.VideoPlayer', {
  renderVideoPlayerPage: renderVideoPlayerPage,
});

registerForRails({
  TruncateText,
});
